// src/data/caseStudies.js
export const caseStudies = [
    
    {
      id: "fintech-payment-platform",
      title: "Next-Gen Payment Platform",
      industry: "Finance",
      technologies: ["Blockchain", "React", "Node.js", "Security Protocols"],
      image: "/images/case-studies/payment-platform.jpg",
      description: "Developed a secure, scalable payment processing platform for a fintech startup, handling over $500M in transactions within the first year of deployment.",
      results: [
        "99.99% uptime with zero security breaches",
        "Processing capacity of 10,000 transactions per second",
        "90% reduction in transaction processing time",
        "Seamless integration with multiple banking systems"
      ],
      challenge: "The fintech company needed a highly secure, scalable platform that could handle rapid growth while meeting strict financial regulations and integrating with legacy banking systems.",
      solution: "We engineered a microservices-based architecture with blockchain elements for transaction integrity, advanced encryption, and comprehensive audit trails while maintaining an intuitive user experience."
    },
    {
      id: "smart-city-infrastructure",
      title: "Smart City Infrastructure",
      industry: "Government",
      technologies: ["IoT", "Big Data", "Cloud Computing", "Mobile Apps"],
      image: "/images/case-studies/smart-city.jpg",
      description: "Created a comprehensive smart city platform for a municipal government, improving traffic flow by 35% and reducing energy consumption by 20%.",
      results: [
        "35% improvement in traffic flow",
        "20% reduction in municipal energy usage",
        "50% faster emergency response times",
        "Citizen engagement increased by 60% through mobile app"
      ],
      challenge: "The city was facing growing congestion, rising energy costs, and difficulty coordinating essential services efficiently while meeting citizen expectations for digital engagement.",
      solution: "We implemented an integrated system of IoT sensors, centralized data analytics, and citizen-facing applications to optimize city operations and improve service delivery across transportation, energy, and public safety."
    },
    {
      id: "renewable-energy-optimization",
      title: "Renewable Energy Optimization",
      industry: "Energy",
      technologies: ["AI/ML", "IoT", "Data Analytics", "Cloud Computing"],
      image: "/images/case-studies/renewable-energy.jpg",
      description: "Developed an AI-powered optimization system for a renewable energy provider, increasing energy generation efficiency by 25% and improving grid integration.",
      results: [
        "25% increase in energy generation efficiency",
        "40% improvement in forecasting accuracy",
        "Seamless integration with existing grid infrastructure",
        "15% reduction in operational costs"
      ],
      challenge: "The renewable energy company was struggling with unpredictable generation patterns and inefficient resource allocation, limiting their ability to maximize power output and profitability.",
      solution: "Our AI system analyzes weather patterns, historical performance data, and grid demands to optimize the operation of solar arrays and wind turbines in real-time, while improving forecasting and maintenance scheduling."
    },
    {
      id: "logistics-optimization-platform",
      title: "Logistics Optimization Platform",
      industry: "Logistics",
      technologies: ["AI/ML", "Mobile Apps", "IoT", "Cloud Computing"],
      image: "/images/case-studies/logistics.jpg",
      description: "Built an end-to-end logistics optimization platform for a global shipping company, reducing delivery times by 30% and operational costs by 25%.",
      results: [
        "30% reduction in average delivery times",
        "25% decrease in operational costs",
        "60% improvement in route efficiency",
        "Real-time tracking and visibility across the entire supply chain"
      ],
      challenge: "The logistics company had fragmented systems leading to inefficient routing, poor visibility of assets, and difficulty adapting to changing conditions or disruptions.",
      solution: "We created an integrated platform that uses AI for optimal routing and resource allocation, IoT for real-time tracking, and mobile applications for drivers and customers to maintain visibility throughout the delivery process."
    },

    {
      id: "energy-management-platform",
      title: "Energy Management Platform",
      industry: "Energy",
      technologies: ["AI/ML", "Cloud Computing", "IoT", "Data Analytics"],
      image: "/images/case-studies/energy-platform.jpg",
      description: "Developed an AI-powered energy management system for a leading energy provider, resulting in a 30% reduction in operational costs and improved grid reliability.",
      results: [
        "30% reduction in operational costs",
        "15% improvement in grid reliability",
        "Real-time monitoring of energy consumption patterns",
        "Predictive maintenance capabilities reducing downtime by 40%"
      ],
      challenge: "The client was struggling with outdated infrastructure that couldn't handle increasing demands, resulting in inefficient operations, high maintenance costs, and limited visibility into their distribution network.",
      solution: "We implemented a comprehensive IoT-based system with AI analytics capabilities to optimize energy distribution, monitor grid performance in real-time, and predict maintenance needs before equipment failures occurred."
    },
    {
      id: "blockchain-supply-chain",
      title: "Blockchain Supply Chain Solution",
      industry: "Manufacturing",
      technologies: ["Blockchain", "Smart Contracts", "Mobile Apps", "Cloud Computing"],
      image: "/images/case-studies/blockchain-supply.jpg",
      description: "Created a transparent and secure blockchain-based supply chain system for a global manufacturer, improving traceability and reducing fraud by 90%.",
      results: [
        "90% reduction in supply chain fraud incidents",
        "Complete end-to-end traceability of products",
        "60% faster verification of material sources and certifications",
        "25% reduction in administrative overhead"
      ],
      challenge: "The manufacturer was facing issues with counterfeit components, lack of transparency across multiple supply chain tiers, and difficulty verifying ethical sourcing claims.",
      solution: "We developed a blockchain solution that creates immutable records for every component and transaction throughout the supply chain, with smart contracts automating verification and compliance processes."
    },
    {
      id: "telemedicine-platform",
      title: "Telemedicine Platform",
      industry: "Healthcare",
      technologies: ["React", "Node.js", "WebRTC", "HIPAA Compliance"],
      image: "/images/case-studies/telemedicine.jpg",
      description: "Built a secure, HIPAA-compliant telemedicine platform for a healthcare network, increasing patient reach by 200% and reducing operational costs by 40%.",
      results: [
        "200% increase in patient reach",
        "40% reduction in operational costs",
        "95% patient satisfaction rate",
        "Seamless integration with existing EHR systems"
      ],
      challenge: "The healthcare provider needed to expand services to remote locations while maintaining security and compliance with healthcare regulations during the rapid shift to digital healthcare delivery.",
      solution: "We developed a secure video consultation platform with integrated electronic health records, appointment scheduling, secure messaging, and prescription management capabilities."
    },
    {
      id: "predictive-maintenance-oil",
      title: "Predictive Maintenance System",
      industry: "Oil & Gas",
      technologies: ["IoT", "AI/ML", "Cloud Computing", "Data Analytics"],
      image: "/images/case-studies/predictive-maintenance.jpg",
      description: "Implemented an IoT and AI-driven predictive maintenance system for an oil & gas company, reducing equipment failures by 45% and maintenance costs by 30%.",
      results: [
        "45% reduction in unexpected equipment failures",
        "30% decrease in maintenance costs",
        "20% improvement in equipment lifespan",
        "Real-time monitoring of all critical assets"
      ],
      challenge: "The company was experiencing costly unplanned downtime due to equipment failures at remote extraction sites, with traditional scheduled maintenance proving insufficient.",
      solution: "Our solution deployed IoT sensors across critical equipment to collect real-time performance data, which is analyzed by machine learning algorithms to predict potential failures before they occur."
    },
    {
      id: "fintech-payment-platform",
      title: "Next-Gen Payment Platform",
      industry: "Finance",
      technologies: ["Blockchain", "React", "Node.js", "Security Protocols"],
      image: "/images/case-studies/payment-platform.jpg",
      description: "Developed a secure, scalable payment processing platform for a fintech startup, handling over $500M in transactions within the first year of deployment.",
      results: [
        "99.99% uptime with zero security breaches",
        "Processing capacity of 10,000 transactions per second",
        "90% reduction in transaction processing time",
        "Seamless integration with multiple banking systems"
      ],
      challenge: "The fintech company needed a highly secure, scalable platform that could handle rapid growth while meeting strict financial regulations and integrating with legacy banking systems.",
      solution: "We engineered a microservices-based architecture with blockchain elements for transaction integrity, advanced encryption, and comprehensive audit trails while maintaining an intuitive user experience."
    },
    {
      id: "smart-city-infrastructure",
      title: "Smart City Infrastructure",
      industry: "Government",
      technologies: ["IoT", "Big Data", "Cloud Computing", "Mobile Apps"],
      image: "/images/case-studies/smart-city.jpg",
      description: "Created a comprehensive smart city platform for a municipal government, improving traffic flow by 35% and reducing energy consumption by 20%.",
      results: [
        "35% improvement in traffic flow",
        "20% reduction in municipal energy usage",
        "50% faster emergency response times",
        "Citizen engagement increased by 60% through mobile app"
      ],
      challenge: "The city was facing growing congestion, rising energy costs, and difficulty coordinating essential services efficiently while meeting citizen expectations for digital engagement.",
      solution: "We implemented an integrated system of IoT sensors, centralized data analytics, and citizen-facing applications to optimize city operations and improve service delivery across transportation, energy, and public safety."
    },
    {
      id: "renewable-energy-optimization",
      title: "Renewable Energy Optimization",
      industry: "Energy",
      technologies: ["AI/ML", "IoT", "Data Analytics", "Cloud Computing"],
      image: "/images/case-studies/renewable-energy.jpg",
      description: "Developed an AI-powered optimization system for a renewable energy provider, increasing energy generation efficiency by 25% and improving grid integration.",
      results: [
        "25% increase in energy generation efficiency",
        "40% improvement in forecasting accuracy",
        "Seamless integration with existing grid infrastructure",
        "15% reduction in operational costs"
      ],
      challenge: "The renewable energy company was struggling with unpredictable generation patterns and inefficient resource allocation, limiting their ability to maximize power output and profitability.",
      solution: "Our AI system analyzes weather patterns, historical performance data, and grid demands to optimize the operation of solar arrays and wind turbines in real-time, while improving forecasting and maintenance scheduling."
    },
    {
      id: "logistics-optimization-platform",
      title: "Logistics Optimization Platform",
      industry: "Logistics",
      technologies: ["AI/ML", "Mobile Apps", "IoT", "Cloud Computing"],
      image: "/images/case-studies/logistics.jpg",
      description: "Built an end-to-end logistics optimization platform for a global shipping company, reducing delivery times by 30% and operational costs by 25%.",
      results: [
        "30% reduction in average delivery times",
        "25% decrease in operational costs",
        "60% improvement in route efficiency",
        "Real-time tracking and visibility across the entire supply chain"
      ],
      challenge: "The logistics company had fragmented systems leading to inefficient routing, poor visibility of assets, and difficulty adapting to changing conditions or disruptions.",
      solution: "We created an integrated platform that uses AI for optimal routing and resource allocation, IoT for real-time tracking, and mobile applications for drivers and customers to maintain visibility throughout the delivery process."
    },
    {
      id: "besta-community-app",
      title: "Besta Community Platform",
      industry: "Social Networking",
      technologies: ["React Native", "Firebase", "Node.js", "MongoDB"],
      image: "/images/case-studies/besta-community.jpg",
      description: "Created a community-driven mobile application connecting like-minded individuals based on shared interests, resulting in over 500,000 users within six months of launch.",
      results: [
        "500,000+ active users within first six months",
        "Average session time of 23 minutes",
        "87% user retention rate",
        "4.8/5 app store rating with 50,000+ reviews"
      ],
      challenge: "The market lacked a specialized platform for connecting people with shared interests in an authentic, privacy-focused environment free from data exploitation.",
      solution: "We built a feature-rich community platform with interest-based matching algorithms, real-time chat, event organization tools, and content sharing capabilities, all with robust privacy controls."
    },
    {
      id: "medicare-medicals",
      title: "Medicare Medicals Platform",
      industry: "Healthcare",
      technologies: ["Angular", "Python", "AI/ML", "FHIR Compliance"],
      image: "/images/case-studies/medicare-medicals.jpg",
      description: "Developed an integrated healthcare management system for Medicare providers, improving patient outcomes by 35% and reducing administrative overhead by 45%.",
      results: [
        "35% improvement in patient health outcomes",
        "45% reduction in administrative overhead",
        "60% faster insurance claim processing",
        "Complete HIPAA and FHIR compliance with zero data breaches"
      ],
      challenge: "Medicare providers were struggling with fragmented systems, complex compliance requirements, and inefficient workflows that impacted both patient care and operational efficiency.",
      solution: "Our integrated platform streamlined patient data management, automated compliance checks, optimized claim processing, and provided AI-driven insights for care recommendations."
    },
    {
      id: "loanwala-blockchain",
      title: "LoanWala Blockchain Lending",
      industry: "Finance",
      technologies: ["Blockchain", "Smart Contracts", "React", "Node.js"],
      image: "/images/case-studies/loanwala.jpg",
      description: "Built a peer-to-peer blockchain lending platform that has facilitated over $75M in loans with 65% lower interest rates than traditional financial institutions.",
      results: [
        "65% lower average interest rates than traditional banks",
        "$75M+ in facilitated loans",
        "Default rate of just 2.3% (75% lower than industry average)",
        "Average loan approval and funding time of 4 hours"
      ],
      challenge: "Traditional lending systems were excluding viable borrowers, charging excessive fees, and suffering from slow processing times and lack of transparency.",
      solution: "We created a decentralized lending platform using blockchain and smart contracts to automate loan approvals, manage repayments, and create a transparent marketplace connecting lenders directly with borrowers."
    },
    {
      id: "lamasala-grocery",
      title: "LaMasala E-Commerce Platform",
      industry: "Retail",
      technologies: ["React", "Node.js", "MongoDB", "AWS"],
      image: "/images/case-studies/lamasala-grocery.jpg",
      description: "Developed a specialized grocery e-commerce platform focused on authentic international ingredients, achieving 250% year-over-year growth and 98% customer satisfaction.",
      results: [
        "250% YoY growth in first two years",
        "98% customer satisfaction rating",
        "Average order value 35% higher than industry standard",
        "30-minute delivery guarantee in urban areas with 99.2% success rate"
      ],
      challenge: "Ethnic and international grocery shoppers were underserved by mainstream platforms, with limited product selection, poor quality, and lack of cultural context or expertise.",
      solution: "We built a specialized e-commerce platform with sourcing from authentic suppliers, expert product curation, recipe integration, and ultra-fast delivery logistics optimized for specialty groceries."
    },
    {
      id: "seeds-farm-blockchain",
      title: "1Seeds Decentralized Farming Finance",
      industry: "Agriculture",
      technologies: ["Blockchain", "Smart Contracts", "React", "IoT"],
      image: "/images/case-studies/seeds-farm.jpg",
      description: "Created a blockchain-based platform connecting investors directly with farmers, facilitating $25M in direct funding and increasing farmer profits by 40%.",
      results: [
        "$25M in direct farm funding",
        "40% increase in farmer profits",
        "25% reduction in food waste through optimized supply chains",
        "Complete traceability from farm to table for all products"
      ],
      challenge: "Small and medium-sized farmers were struggling with limited access to capital, price volatility, and exploitation by intermediaries, while consumers lacked transparency about food sources.",
      solution: "Our platform enables direct investment in farms through tokenization, provides real-time monitoring of crops via IoT sensors, and creates transparent supply chains with fair pricing models."
    },
    {
      id: "ai-assistant-enterprise",
      title: "Enterprise AI Assistant Platform",
      industry: "Technology",
      technologies: ["NLP", "Machine Learning", "Python", "Cloud Computing"],
      image: "/images/case-studies/ai-assistant.jpg",
      description: "Developed a customizable enterprise AI assistant platform that increased productivity by 35% across client organizations while reducing support ticket volume by 65%.",
      results: [
        "35% increase in employee productivity",
        "65% reduction in IT and HR support tickets",
        "87% accuracy in complex query resolution",
        "92% employee adoption rate within 3 months"
      ],
      challenge: "Organizations were struggling with information silos, repetitive employee queries across departments, and inefficient knowledge transfer leading to productivity losses.",
      solution: "We built an AI platform that integrates with enterprise systems, learns from company documentation, and provides contextual assistance through natural language interactions while continuously improving through feedback."
    },
    {
      id: "tech-academy-platform",
      title: "Comprehensive Tech Academy",
      industry: "Education",
      technologies: ["React", "Node.js", "GraphQL", "AI/ML"],
      image: "/images/case-studies/tech-academy.jpg",
      description: "Created an adaptive learning platform for technology education that achieved 85% course completion rates and placed 92% of graduates in tech jobs within 3 months.",
      results: [
        "85% course completion rate (vs. industry average of 15%)",
        "92% job placement rate within 3 months of graduation",
        "Average graduate salary increase of 65%",
        "98% employer satisfaction with graduate performance"
      ],
      challenge: "Traditional tech education was failing to keep pace with industry needs, resulting in skill gaps, high dropout rates, and graduates unprepared for real-world employment.",
      solution: "Our platform combines adaptive learning algorithms, hands-on project-based assessments, mentorship matching, and employer partnerships with curriculum continuously updated based on industry demand."
    },
    {
      id: "quantum-computing-simulation",
      title: "Quantum Computing Simulation Platform",
      industry: "Technology",
      technologies: ["Quantum Algorithms", "Python", "Cloud Computing", "Linear Algebra"],
      image: "/images/case-studies/quantum-computing.jpg",
      description: "Developed a quantum computing simulation platform that accelerated algorithm development by 300% and reduced computational resource requirements by 70%.",
      results: [
        "300% faster quantum algorithm development cycle",
        "70% reduction in computational resources for simulations",
        "Support for up to 40 qubit simulations",
        "Used by 5 leading research institutions for breakthrough research"
      ],
      challenge: "Access to quantum computing hardware was limited and expensive, while existing simulation tools were inefficient, difficult to use, and failed to accurately model quantum decoherence.",
      solution: "We created a high-performance quantum simulation platform with intuitive visual programming interfaces, extensive algorithm libraries, and accurate noise modeling to accelerate quantum software development."
    },
    {
      id: "geo-ai-analytics",
      title: "Geo-AI Analytics Platform",
      industry: "Geospatial",
      technologies: ["AI/ML", "Satellite Imaging", "Big Data", "Cloud Computing"],
      image: "/images/case-studies/geo-ai.jpg",
      description: "Built an AI-powered geospatial analytics platform that improved agricultural yield predictions by 45% and enabled precision resource management across 5M acres.",
      results: [
        "45% improvement in yield prediction accuracy",
        "30% reduction in water usage",
        "25% decrease in fertilizer application",
        "Near real-time monitoring of 5M acres of agricultural land"
      ],
      challenge: "Agricultural planning relied on limited ground-level data, resulting in inefficient resource usage, environmental impact, and missed optimization opportunities across large areas.",
      solution: "Our platform combines satellite imagery, weather data, soil sensors, and historical yields with machine learning to provide actionable insights for precision agriculture at scale."
    },
    {
      id: "geo-orion-monitoring",
      title: "Geo-Orion Environmental Monitoring",
      industry: "Environmental",
      technologies: ["Remote Sensing", "IoT", "AI/ML", "Cloud Computing"],
      image: "/images/case-studies/geo-orion.jpg",
      description: "Developed a comprehensive environmental monitoring system that detected pollution events 5x faster than traditional methods and reduced monitoring costs by 60%.",
      results: [
        "5x faster detection of environmental anomalies",
        "60% reduction in monitoring costs",
        "95% accuracy in pollutant classification",
        "Successful deployment across 3 major river systems"
      ],
      challenge: "Environmental monitoring systems were costly, slow to detect issues, and provided limited coverage, resulting in delayed responses to contamination events and habitat destruction.",
      solution: "We created a network of low-cost IoT sensors combined with satellite data and machine learning to provide comprehensive environmental monitoring with automated alerts and predictive capabilities."
    },
    {
      id: "xenolith-data-platform",
      title: "Xenolith Data Integration Platform",
      industry: "Enterprise Software",
      technologies: ["ETL", "Apache Kafka", "Hadoop", "Cloud Computing"],
      image: "/images/case-studies/xenolith.jpg",
      description: "Built an enterprise data integration platform that reduced data processing time by 85% and enabled real-time analytics across previously siloed systems.",
      results: [
        "85% reduction in data processing time",
        "Integration of 27 disparate enterprise systems",
        "Real-time data access reducing reporting lag from days to seconds",
        "$3.2M annual savings in operational costs"
      ],
      challenge: "The enterprise was struggling with fragmented data across legacy systems, cloud platforms, and third-party services, preventing unified analytics and timely decision-making.",
      solution: "Our Xenolith platform provides seamless data integration, transformation, and governance across all enterprise data sources with automated pipelines and self-service analytics capabilities."
    },
    {
      id: "maxxies-fashion-platform",
      title: "Maxxies Fashion E-Commerce",
      industry: "Retail",
      technologies: ["React", "Node.js", "AI/ML", "Augmented Reality"],
      image: "/images/case-studies/maxxies-fashion.jpg",
      description: "Created an AI-powered fashion e-commerce platform that increased conversion rates by 45% and reduced returns by 60% through virtual try-on technology.",
      results: [
        "45% increase in conversion rates",
        "60% reduction in product returns",
        "Average order value increased by 35%",
        "Customer retention improved by 40%"
      ],
      challenge: "Online fashion retailers faced high return rates and low conversion due to customers' inability to accurately assess fit, style, and appearance without physical try-on.",
      solution: "We developed an e-commerce platform with AI-powered size recommendations, augmented reality virtual try-on, personalized style suggestions, and social shopping features."
    },
    {
      id: "zenfash-marketplace",
      title: "ZenFash Sustainable Fashion Marketplace",
      industry: "Retail",
      technologies: ["React", "Blockchain", "AI/ML", "Cloud Computing"],
      image: "/images/case-studies/zenfash.jpg",
      description: "Built a blockchain-verified sustainable fashion marketplace that connected eco-conscious consumers with ethical producers, growing to 300,000 customers in first year.",
      results: [
        "300,000 active customers in first year",
        "100% blockchain-verified sustainable supply chain",
        "Carbon footprint reduced by 75% compared to traditional fashion",
        "Featured in 12 major fashion and sustainability publications"
      ],
      challenge: "Eco-conscious consumers struggled to verify sustainability claims from fashion brands, while truly sustainable producers lacked effective channels to reach their target market.",
      solution: "Our platform combines blockchain verification of ethical production, carbon footprint tracking, recycled material certification, and direct producer-to-consumer connections."
    },
    {
      id: "bm-luxury-experience",
      title: "BM Luxury Digital Experience",
      industry: "Luxury Retail",
      technologies: ["React", "3D Rendering", "Augmented Reality", "AI/ML"],
      image: "/images/case-studies/bm-luxury.jpg",
      description: "Developed an immersive digital experience platform for a luxury brand, increasing online sales by 120% and customer engagement time by 300%.",
      results: [
        "120% increase in online luxury goods sales",
        "300% increase in digital engagement time",
        "Average order value 2.5x higher than industry standard",
        "87% of customers rated experience as 'exceptional'"
      ],
      challenge: "Luxury brands struggled to translate their high-touch, exclusive in-store experiences to digital channels, limiting their ability to reach new customers and adapt to changing shopping habits.",
      solution: "We created an immersive platform with virtual showrooms, personalized digital consultations, 3D product exploration, augmented reality try-on, and white-glove digital concierge services."
    },
    {
      id: "relite-iot-lighting",
      title: "Relite IoT Smart Lighting System",
      industry: "Smart Building",
      technologies: ["IoT", "Edge Computing", "Mobile Apps", "Cloud Computing"],
      image: "/images/case-studies/relite.jpg",
      description: "Built an intelligent commercial lighting system that reduced energy consumption by 72% while improving occupant comfort and productivity.",
      results: [
        "72% reduction in lighting-related energy consumption",
        "15% improvement in reported employee productivity",
        "Payback period of just 14 months on implementation costs",
        "30% reduction in maintenance costs through predictive maintenance"
      ],
      challenge: "Commercial buildings were wasting significant energy through inefficient lighting systems that failed to adapt to occupancy, natural light, or user preferences.",
      solution: "We developed an IoT-enabled lighting system with occupancy detection, daylight harvesting, personal preference learning, circadian rhythm optimization, and comprehensive energy analytics."
    },
    {
      id: "flossies-retail-analytics",
      title: "Flossies Retail Analytics Platform",
      industry: "Retail",
      technologies: ["Computer Vision", "AI/ML", "IoT", "Cloud Computing"],
      image: "/images/case-studies/flossies.jpg",
      description: "Created an AI-powered retail analytics platform that increased conversion rates by 35% and optimized staffing efficiency by 28% across 200+ stores.",
      results: [
        "35% increase in in-store conversion rates",
        "28% improvement in staffing efficiency",
        "22% reduction in inventory carrying costs",
        "Real-time insights across 200+ retail locations"
      ],
      challenge: "Brick-and-mortar retailers lacked the data-driven insights available to e-commerce competitors, resulting in suboptimal store layouts, staffing, and merchandising decisions.",
      solution: "Our system uses computer vision, IoT sensors, and AI to analyze customer flows, engagement patterns, product interactions, and conversion funnels to optimize the physical retail experience."
    },
    {
      id: "horzely-vr-platform",
      title: "Horzely VR Training Platform",
      industry: "Education",
      technologies: ["Virtual Reality", "3D Modeling", "Unity", "AI/ML"],
      image: "/images/case-studies/horzely.jpg",
      description: "Developed a VR-based industrial training platform that reduced training time by 60% while improving knowledge retention by 80% and safety compliance.",
      results: [
        "60% reduction in training time",
        "80% improvement in knowledge retention",
        "93% reduction in training-related accidents",
        "Return on investment within 4 months of implementation"
      ],
      challenge: "Industrial training was costly, dangerous, and inefficient, requiring expensive equipment, expert trainers, and failing to adequately prepare workers for high-risk scenarios.",
      solution: "We built a VR training platform with realistic simulations of industrial environments, haptic feedback, adaptive learning paths, and comprehensive performance analytics to accelerate skill development."
    }
  ];
  